export async function fetchHotspots(): Promise<Array<Hotspot>> {
	const resp = await fetch( 'https://hotspots.usbynight.be/wp-json/hotspot/list.json' );

	if ( !resp.ok ) throw new Error( `Failed to fetch hotspots: ${resp.status} ${resp.statusText}` );

	const data = await resp.json() as Array<Hotspot>;

	return data;
}

export type HotspotProperties = {
	popup: string,
	label: string,
	type?: string
}

export function hotspotsAs_GEO_JSON( hotspots: Array<Hotspot> ) {
	const features = hotspots.map( ( hotspot, index ) => {
		if ( ( typeof hotspot.location?.lng === 'undefined' ) || typeof hotspot.location?.lat === 'undefined' ) {
			return null;
		}

		const geometry = {
			type: 'Point',
			coordinates: [
				hotspot.location!.lng,
				hotspot.location!.lat,
			],
		};

		const popupTitle = `<h3 class="hotspots-map__popup__title type-c">${hotspot.title}</h3>`;

		let popupContent = '';
		if ( hotspot.content_plain_text ) {
			popupContent = `<p class="hotspots-map__popup__content type-d">${hotspot.content_plain_text}</p>`;
		}

		let popupLinks = '';
		if ( hotspot.links?.length ) {
			popupLinks = hotspot.links.map( ( item ) => {
				if ( !item.link?.url || !item.link?.title ) {
					return;
				}

				return `
					<li class="hotspots-map__popup__link-list-item">
						<a
							href="${item.link.url}"
							target="${item.link.target ?? '_self'}"
						>
							<span class="type-d">${item.link.title}</span>
						</a>
					</li>
				`;
			} ).filter( Boolean ).join( '' );

			popupLinks = '<ul class="hotspots-map__popup__link-list">' + popupLinks + '</ul>';
		}

		const properties: HotspotProperties = {
			popup: `
				<div class="hotspots-map__popup">
					${popupTitle}
					${popupContent}
					${popupLinks}
				</div>
			`,
			label: ( index + 1 ).toString(),
			type: hotspot.type,
		};

		const feature = {
			id: hotspot.id,
			geometry: geometry,
			type: 'Feature',
			properties: properties,
		};

		return feature;
	} ).filter( ( feature ) => {
		return !!feature;
	} );

	return {
		type: 'FeatureCollection',
		features: features,
	};
}

export function hotspotTypeLabel( hotspotType: string ): string {
	switch ( hotspotType ) {
		case 'food':
			return 'Food';
		case 'sight':
			return 'Sight';
		case 'drinks':
			return 'Drinks';
		case 'fun':
			return 'Fun';
		case 'hotel':
			return 'Hotel';
		case 'everything':
			return 'Everything';

		default:
			return hotspotType;
	}
}


export interface Hotspot {
	id: number
	title: string
	content?: string
	content_plain_text?: string
	type?: string
	poster_image?: string
	links?: Array<{link?: Link}>
	location?: Location
}

export interface Link {
	title?: string
	url?: string
	target?: string
}

export interface Location {
	address?: string
	lat?: number
	lng?: number
	zoom?: number
	place_id?: string
	name?: string
	street_number?: string
	street_name?: string
	city?: string
	state?: string
	state_short?: string
	post_code?: string
	country?: string
	country_short?: string
}
